import { client } from '../client';

export interface PasswordlessVerifyPayload {
  username?: string;
  code?: string;
  token?: string;
  organization_id?: string;
  division_id?: string;
  practice_id?: string;
}

export interface PasswordlessVerifyResponse {
  access_token: string;
  refresh_token: string;
  role?: string;
  redirect_url?: string;
}

export const passwordlessVerify = async (
  payload: PasswordlessVerifyPayload,
): Promise<PasswordlessVerifyResponse> => {
  const { data } = await client.post<PasswordlessVerifyResponse>('/auth/passwordless/verify', payload);
  return data;
};
